
import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import DomainCard from "@/components/channel/DomainCard";
import { Domain } from "@/types/domain";

const domains: Domain[] = [
  {
    symbol: "Logistics Leadership",
    name: "Logistics Leadership",
    categories: "Strategic Planning, Resource Optimization, Performance Management",
    subDomains: ["Inbound", "Infield", "Outbound"]
  },
  {
    symbol: "Transport Management",
    name: "Transport Management",
    categories: "Fleet Operations, Route Optimization, Carrier Management"
  },
  {
    symbol: "Warehousing",
    name: "Warehousing",
    categories: "Inventory Management, Storage Optimization, Material Handling"
  },
  {
    symbol: "Supply Chain",
    name: "Supply Chain",
    categories: "Demand Planning, Procurement, Vendor Management"
  },
  {
    symbol: "Health & Safety",
    name: "Health & Safety",
    categories: "Safety Protocols, Risk Management, Emergency Response"
  },
  {
    symbol: "Compliance",
    name: "Compliance",
    categories: "Regulatory Requirements, Documentation, Auditing"
  },
  {
    symbol: "Quality Control",
    name: "Quality Control",
    categories: "Quality Assurance, Testing, Inspection Protocols"
  },
  {
    symbol: "Data Analytics",
    name: "Data Analytics",
    categories: "Performance Metrics, Predictive Analytics, Reporting"
  },
  {
    symbol: "Sustainability",
    name: "Sustainability",
    categories: "Environmental Impact, Green Logistics, Carbon Footprint"
  },
  {
    symbol: "Innovation Tech",
    name: "Innovation Tech",
    categories: "Digital Solutions, Automation, IoT Integration"
  }
];

const ExxonMobilChannel = () => {
  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Card className="mb-6">
          <CardHeader>
            <div className="flex items-center gap-6">
              <img 
                src="/lovable-uploads/6520fa33-8262-47da-95a9-fb17b9e26713.png" 
                alt="ExxonMobil Logo" 
                className="w-48 h-48 object-contain"
              />
              <div>
                <CardTitle className="text-2xl font-bold mb-2">ExxonMobil Upstream Logistics</CardTitle>
                <CardDescription className="text-lg">
                  Optimizing Upstream Oil & Gas Logistics Operations
                </CardDescription>
                <Button 
                  variant="link" 
                  className="p-0 h-auto text-primary hover:text-primary/80 flex items-center gap-2"
                  onClick={() => window.open('https://corporate.exxonmobil.com/', '_blank')}
                >
                  Visit ExxonMobil Website
                  <ExternalLink className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <h2 className="text-xl font-semibold mb-4">Oil & Gas Upstream Logistics Domain Elements</h2>
            <div className="grid grid-cols-5 gap-2">
              {domains.map((domain) => (
                <DomainCard key={domain.symbol} domain={domain} />
              ))}
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default ExxonMobilChannel;
